<template>
    <router-view />
</template>

<script>

export default {
    name: 'language-selector',
}
</script>